export const RankingCardSkeleton = () => {
  return (
    <div className="flex items-center gap-4 p-2 rounded-lg bg-white/10 animate-pulse">
      <div className="w-6 h-6 rounded-full bg-gray-500/50"></div>
      <div className="w-12 h-12 rounded-full bg-gray-500/50"></div>
      <div className="flex-grow flex flex-col gap-2">
        <div className="h-4 w-3/4 rounded bg-gray-500/50"></div>
        <div className="h-3 w-1/2 rounded bg-gray-500/50"></div>
      </div>
      <div className="w-10 h-10 rounded-lg bg-gray-500/50"></div>
    </div>
  )
}
